import { ApiCallState } from "../Utils";
import { User } from "../User/User.type";

export type TaxPayment = {
  id: number;
  payment_type: "ERCA" | "INCOME_TAX" | "E_PAYMENT" | string;
  date: string;
  document_number: string;
  tax_payer_name: string;
  payer_account_number: string;
  beneficiary_name: string;
  beneficiary_account_number: string;
  amount: number;
  payment_details: string;
  tin_number: string;
  user_id?: number;
  user?: User;
  statuses?: any[];
  tax_payment_statuses?: any[];
  createdAt?: any;
  updatedAt?: any;
};

export type TaxPaymentStateTypes = {
  fetchAll: ApiCallState<TaxPayment[]>;
  fetchOne: ApiCallState<TaxPayment | {}>;
};

export const TaxPaymentActionTypes = {
  FETCH_ALL_TAX_PAYMENT: "FETCH_ALL_TAX_PAYMENT",
  FETCH_ALL_TAX_PAYMENT_RESET: "FETCH_ALL_TAX_PAYMENT_RESET",
  FETCH_ALL_TAX_PAYMENT_FAILURE: "FETCH_ALL_TAX_PAYMENT_FAILURE",
  FETCH_ALL_TAX_PAYMENT_SUCCESS: "FETCH_ALL_TAX_PAYMENT_SUCCESS",

  FETCH_ONE_TAX_PAYMENT: "FETCH_ONE_TAX_PAYMENT",
  FETCH_ONE_TAX_PAYMENT_RESET: "FETCH_ONE_TAX_PAYMENT_RESET",
  FETCH_ONE_TAX_PAYMENT_FAILURE: "FETCH_ONE_TAX_PAYMENT_FAILURE",
  FETCH_ONE_TAX_PAYMENT_SUCCESS: "FETCH_ONE_TAX_PAYMENT_SUCCESS",
};
